import React from 'react'
import { observer } from 'mobx-react'
import { SelectFilter } from 'infra/FilterControls/Select/SelectFilter'
import { DocumentManagementViewModel } from '../DocumentManagementViewModel'
import styles from './DocumentCount.sass'

interface DocumentCountProps {
  vm: DocumentManagementViewModel
}

export default observer(function DocumentCount({ vm }: DocumentCountProps) {
  const totalDocuments = vm.searcher.totalDocuments
  const archivedFilter = vm.searcher.filters.getFilter(
    'archived',
  ) as SelectFilter<'archived', boolean | undefined>

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {toArchivedStatus(archivedFilter?.value.slice())}
        <span className={styles.count}>&nbsp;({totalDocuments ?? 0})</span>
      </div>
    </div>
  )
})

function toArchivedStatus(archivedFilterValue: Array<boolean | undefined>) {
  switch (archivedFilterValue?.pop()) {
    case true:
      return 'Archived documents'
    case false:
      return 'Unarchived documents'
    default:
      return 'All documents'
  }
}
